import { render, staticRenderFns } from "./ConsultaTipoChavePix.vue?vue&type=template&id=37cc96c2&"
import script from "./ConsultaTipoChavePix.vue?vue&type=script&lang=js&"
export * from "./ConsultaTipoChavePix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports